import type { ComponentType } from "react";
import { Registry } from "scantling-common";

export interface Tip {
  type: string;
  order: number;
  component: ComponentType;
}

export const tipRegistry = new Registry<Tip>();

export function getTips(): Tip[] {
  return tipRegistry.getAll().sort((a, b) => a.order - b.order);
}

export function getTopTip(): Tip | undefined {
  return getTips()[0];
}
